import React from "react";
import Contacts from "./Contacts/Contacts";
import { Container } from "@mui/material";
import Skills from "./Skills/Skills.js";
import Greeting from "./Greeting/Greeting";
import Education from "./Education/Education";
import Experience from "./Experience/Experience";
import ProjectsSliderUKR from "./Projects/ProjectsSliderUKR";

const UKRresume = () => {
  return (
    <>
      <div className="ukr-resume">
        <Greeting />
        <Container maxWidth="lg">
          <Education />
          <Experience />
          <ProjectsSliderUKR />
        </Container>
        <Container maxWidth="lg">
          <Skills />
          <Contacts />
        </Container>
      </div>
    </>
  );
};
export default UKRresume;
